import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import $ from 'jquery';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { merge } from 'rxjs';
import { TicketRightPanelService } from '../../../core/services/ticket-right-panel.service';
import { RightPanelService } from '../../../core/services/right-panel.service';

@Component({
    selector: 'app-resizer',
    templateUrl: './resizer.component.html',
    styleUrls: ['./resizer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizerComponent implements AfterViewInit {
    @Input() resizerDependent;
    @Input() resizerDependentMin;
    @Input() resizerLeft;
    @Input() resizerMain;
    @Input() resizerMax;
    @Input() resizerMin;
    @Input() resizerRight;
    @Input() resizerSide;
    @Input() resizerWidth;

    private prevEventPageX;
    private resizer;
    private readonly rightPanelWidth = 300;
    private widthKey: string;

    constructor(
        private elementRef: ElementRef,
        private windowRef: WindowRef,
        private rightPanelService: RightPanelService,
        private ticketRightPanelService: TicketRightPanelService,
    ) {}

    ngAfterViewInit() {
        this.resizer = this.elementRef.nativeElement.querySelector('.resizer');
        this.widthKey = 'widthOf' + this.resizerMain;
        const previousWidth = this.windowRef.nativeWindow.localStorage.getItem(this.widthKey);

        if (previousWidth || $(this.resizerDependent).width() < this.getResizerDependentMin()) {
            this.updateWidth(+previousWidth);
        }

        this.checkWindowSize = this.checkWindowSize.bind(this);
        this.mousemove = this.mousemove.bind(this);
        this.mouseup = this.mouseup.bind(this);

        $(this.elementRef.nativeElement).on('mousedown', (event) => {
            event.preventDefault();

            $(this.windowRef.nativeWindow.document).on('mousemove', this.mousemove);
            $(this.windowRef.nativeWindow.document).on('mouseup', this.mouseup);
        });

        $(window).on('resize', this.checkWindowSize);

        merge(
            this.rightPanelService.onToggleRightPanelSubject,
            this.ticketRightPanelService.onToggleRightPanelSubject,
        ).subscribe({
            next: () => {
                setTimeout(() => {
                    this.checkWindowSize();
                });
            },
        });

        setTimeout(() => {
            this.updateWidth();
        }, 300);
    }

    private checkWindowSize() {
        const mq = this.windowRef.nativeWindow.matchMedia('(max-width: 1000px)');

        if (mq.matches) {
            $(this.resizerMain).removeAttr('style');
            $(this.resizerDependent).removeAttr('style');
        }

        this.updateWidth();

        return mq.matches;
    }

    private limitNewElementSize(newWidth) {
        if (this.resizerMax && newWidth > this.resizerMax) {
            newWidth = this.resizerMax;
        } else if (this.resizerMin && newWidth < this.resizerMin) {
            newWidth = this.resizerMin;
        }

        const containerWidth = $($('.ticket-list-container')[0]).width();

        if ($(this.resizerDependent).width() < this.getResizerDependentMin()) {
            newWidth = containerWidth - this.getResizerDependentMin() - this.resizerWidth;
        }

        if (containerWidth - newWidth < this.getResizerDependentMin()) {
            newWidth = undefined;
        }

        return newWidth;
    }

    private getResizerDependentMin(): number {
        const mq = this.windowRef.nativeWindow.matchMedia('(max-width: 1450px)'); // 1450 - width when right panel starts to cover content

        if (
            !mq.matches &&
            (this.rightPanelService.isRightPanelOpened || this.ticketRightPanelService.isRightPanelOpened)
        ) {
            return this.resizerDependentMin + this.rightPanelWidth;
        } else {
            return this.resizerDependentMin;
        }
    }

    private mousemove(event) {
        this.resizer.classList.add('resizer-dragging');

        if (this.checkWindowSize()) {
            return;
        }

        // Handle vertical resizer
        if (!event.pageX && !this.prevEventPageX) {
            return;
        }

        let eventPageX = event.pageX;
        if (!eventPageX) {
            eventPageX = this.prevEventPageX;
        } else {
            this.prevEventPageX = event.pageX;
        }

        let newWidth;

        if (this.resizerSide === 'left') {
            newWidth = eventPageX - $(this.resizerLeft).offset().left;
        } else {
            newWidth = $(this.resizerRight).offset().left - eventPageX + $(this.resizerRight).width();
        }

        this.updateWidth(newWidth);

        this.windowRef.nativeWindow.localStorage.setItem(this.widthKey, newWidth);
    }

    private mouseup() {
        this.resizer.classList.remove('resizer-dragging');

        if (this.checkWindowSize()) {
            return;
        }

        $(this.windowRef.nativeWindow.document).off('mousemove', this.mousemove);
        $(this.windowRef.nativeWindow.document).off('mouseup', this.mouseup);
    }

    private updateWidth(newWidth?: number) {
        newWidth = this.limitNewElementSize(newWidth);

        if (!newWidth) {
            return;
        }

        $(this.resizerMain).css({
            width: newWidth,
        });

        $(this.resizerDependent).css({
            width: 'calc(100% - ' + (newWidth + this.resizerWidth) + 'px)',
        });

        $('#ticket-detail-panel .sticky').css('width', $('#ticket-detail-panel').outerWidth());
    }
}
